/* Creazione della polyline del percoso */

//import L, { imageOverlay } from "leaflet";
import { useEffect } from "react";
import { useLeaflet } from "react-leaflet";
import { connect } from 'react-redux';
import * as WMS from "leaflet.wms";
/*import ovalStart from './start.png'
import ovalEnd from './finish.png'
import bus from './bus.png'
import { source } from "leaflet.wms";
*/



const Percorso = (props) => {
    
    const { map } = useLeaflet();

    const options = {
      "version": "1.1.0",
      "format": "image/png",
      "transparent": "true", 
      "info_format": "application/json",
      "opacity": 1,
      //"zIndex": -1
       "cql_filter": "1 = 0",
       fetchOptions: {headers: window.tp_headers}
  }
    const source = WMS.source(
      window.configFile.httpProxy.urlGeoserver,
      //"/geoserver/sardegna/wms?",
        options
  );
  
  const removeLayer = (map,nome) => {
   
    map.eachLayer(element => {
        
      if ( element._name === nome) {
        try { map.removeLayer(element)}
        catch(e) {}
      }
      
      
    }); 
    
    }

    useEffect(() => {
      try {
        source.getLayer("init").addTo(map)
        //source.getLayer("Aeroporti").addTo(map)
      } catch (error) {}
    },[]);
    return null; 
};



const mapStateToProps = state => {
  return {
      pathData: state.path,
      indexSelected: state.index,
      polyReal : state.polyReal
  }
}
export default connect(mapStateToProps)(Percorso);


